import { FormControlLabel, FormLabel, Radio, RadioGroup, Stack } from '@mui/material';
import React, { useState, useEffect } from 'react';

function RadioButton({ renderCreditFields, name, onChange, initialValue }) {
  const [value, setValue] = useState(initialValue || false);

  useEffect(() => {
    setValue(initialValue || false);
  }, [initialValue]);

  const handleChange = (event) => {
    const newValue = event.target.value === "true";
    setValue(newValue);
    onChange(name, newValue);
    if(!newValue) {
      onChange("creditLimit", 0);
    }
  };

  return (
    <>
      <FormLabel id="radio-buttons-group">Condición de pago</FormLabel>
      <RadioGroup
        aria-labelledby="radio-buttons-group"
        name={name}
        value={value.toString()}
        onChange={handleChange}
        row
      >
        <FormControlLabel value="false" control={<Radio />} label="Contado" />
        <FormControlLabel value="true" control={<Radio />} label="Crédito" />
      </RadioGroup>

      {value && (
        <Stack spacing={2} direction="row">
          {renderCreditFields()}
        </Stack>
      )}
    </>
  );
}

export default RadioButton;